// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2_W9f","filesListContainer":"PosDisputesFiles_filesListContainer__1_G1a","filesButton":"PosDisputesFiles_filesButton__1e69k"};